module.exports = __webpack_public_path__ + "media/images/mobile/home/type4-bf89daf8fa420e22534a15d5f203eaa0.png";